import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledPoint = styled.div`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  margin: ${(props) => props.margin};

  @media (max-width: 1399px) {
    margin: ${(props) =>
      props.margin === 'auto' ? 'auto' : `calc(${props.margin} * 0.9)`};
    width: ${(props) => props.width * 0.9}px;
    height: ${(props) => props.height * 0.9}px;
  }
  @media (max-width: 1199px) {
    margin: ${(props) =>
      props.margin === 'auto' ? 'auto' : `calc(${props.margin} * 0.8)`};
    width: ${(props) => props.width * 0.8}px;
    height: ${(props) => props.height * 0.8}px;
  }
  @media (max-width: 991px) {
    margin: ${(props) =>
      props.margin === 'auto' ? 'auto' : `calc(${props.margin} * 0.7)`};
    width: ${(props) => props.width * 0.7}px;
    height: ${(props) => props.height * 0.7}px;
  }
  @media (max-width: 767px) {
    margin: ${(props) =>
      props.margin === 'auto' ? 'auto' : `calc(${props.margin} * 0.6)`};
    width: ${(props) => props.width * 0.6}px;
    height: ${(props) => props.height * 0.6}px;
  }
`

export const Point = ({
  pointWidth = 18,
  pointHeight = 18,
  pointRadius = 0,
  pointMargin = '0 auto',
}) => (
  <StyledPoint
    width={pointWidth}
    height={pointHeight}
    margin={pointMargin}
    style={{
      backgroundColor: '#2D9ADF',
      borderRadius: `${pointRadius}`,
    }}
  />
)

// props type
Point.propTypes = {
  pointWidth: PropTypes.number,
  pointHeight: PropTypes.number,
  pointRadius: PropTypes.string,
  pointMargin: PropTypes.string,
}
